import { createFlowAnalyticsTracker } from "../../utils/flowAnalytics/createFlowAnalyticsTracker.js";
import searchFlowStepRegistry from "./searchFlowStepRegistry.js";

export { FLOW_ANALYTICS_ACTIONS } from "../../utils/flowAnalytics/createFlowAnalyticsTracker.js";

export const createSearchFlowAnalytics = ({
  getSearchId,
  getSteps,
  getFlowInstance,
  entryFlow = "asp",
}) =>
  createFlowAnalyticsTracker({
    getSearchId,
    getSteps,
    getFlowInstance,
    entryFlow,
    stepRegistry: searchFlowStepRegistry,
  });
